import { css, styled } from '@kitopi-com/customer-auth';

export const LangButton = styled('button')<{ isActive: boolean }>(({ theme, isActive }) => {
  const colors = theme.colors?.kitopiColors;
  return css`
    font-size: 15px;
    cursor: pointer;
    background-color: ${isActive ? colors?.neutral500 : colors?.transparent};
    outline: none;
    margin: 0 2px;
    color: ${colors?.kitopiWhite};
    border: none;
    padding: 5px 10px;
  `;
});

export const Container = styled('div')(
  ({ theme }) => css`
    > * {
      font-family: ${theme.globalFontFamily};
    }
    color: ${theme.colors?.kitopiColors.kitopiWhite};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 1000;
  `
);

export const ProfileSection = styled('div')`
  display: flex;
  align-items: center;
`;
